/**
 * Created by dorin on 6/22/17.
 */
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { find, propEq } from 'ramda';
import countries from 'country-calling-code';
import cookie from 'react-cookies';
import moment from 'moment';
import _ from 'lodash';
// import { ReCaptcha } from 'react-recaptcha-v3';
import {
  Row,
  Col,
  Form,
  FormGroup,
  FormControl,
  Checkbox,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
// import PhoneVerify from '../PhoneVerify';
// import { GOOGLE_RECPATCHA_KEY, COSYND_TERMS_PRIVACY_LINK } from '../../constants';
import { COSYND_TERMS_PRIVACY_LINK, REFERRER_IDS } from '../../constants';
import Turnstile from './Turnstile';

class Signup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      password: '',
      confirmPassword: '',
      address: '',
      city: '',
      state: '',
      postal: '',
      country: '',
      countryCode: '',
      tel: '',
      phoneVerified: false,
      verifiedNumber: null,
      verifiedCountryCode: null,
      attorney: false,
      terms: false,
      creator: false,
      referrerId: null,
      turnstileToken: null,
    };
  }

  componentWillMount() {
    const refKey = this.props.params.key;
    const referrerId = this.props.params.refId;
    const cookieReferrerId = cookie.load('referrerId');

    if (refKey === 'plan') {
      // save the subscriptin plan (selected from pricing page before registration) in the cookie
      cookie.save('signupPlan', referrerId, {
        path: '/',
      });
    } else {
      if (refKey === 'ref') {
        const planKey = this.props.params.plan;
        if (planKey && planKey === 'plan') {
          // save the subscriptin plan (selected from pricing page before registration) in the cookie
          const planId = this.props.params.planId;
          cookie.save('signupPlan', planId, {
            path: '/',
          });
        }

        // if (cookieReferrerId) {
        //   this.setState({ referrerId: cookieReferrerId });
        // } else {
        const expires = moment().add(45, 'd').toDate();
        cookie.save('referrerId', referrerId, {
          path: '/',
          expires,
        });
        this.setState({ referrerId });
        // }
      } else if (cookieReferrerId) {
        this.setState({ referrerId: cookieReferrerId });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { status, error, dispatch } = nextProps;

    if (this.props.status !== status) {
      if (status === actionTypes.AUTH_SIGNUP_SUCCESS) {
        dispatch(
          actions.alert(
            'success',
            'Please check your inbox and follow the directions to verify your email address.'
          )
        );
        this.props.router.push('/login');
      } else if (status === actionTypes.AUTH_SIGNUP_ERROR) {
        if (error) {
          if (error === 'BOT_ERROR') {
            this.resetTurnstile();
            dispatch(
              actions.alert(
                'error',
                'An error has occurred. Please contact help@cosynd.com for assistance.'
              )
            );
            return;
          }
          const errors = Object.values(error);
          errors.forEach((e) => dispatch(actions.alert('error', e[0])));
        } else {
          dispatch(
            actions.alert(
              'success',
              'Please check your inbox and follow the directions to verify your email address.'
            )
          );
          this.props.router.push('/login');
          // dispatch(actions.alert('error', 'Oops! Something went wrong. Please try to register again. If this error persists, please contact us.'));
        }
      }
    }
  }

  handleAttorney = (e) => {
    this.setState({ attorney: e.target.checked });
  };

  handleCreator = (e) => {
    this.setState({ creator: e.target.checked });
  };

  handleTerms = (e) => {
    this.setState({ terms: e.target.checked });
  };

  handleChange = (e) => {
    this.setState({ [e.target.getAttribute('id')]: e.target.value });
  };

  handleCountry = (e) => {
    const country = find(propEq('country', e.target.value))(countries);
    if (country) {
      this.setState(
        { country: country.country, countryCode: country.countryCodes[0] },
        this.checkAlreadyVerified
      );
    } else {
      this.setState({ country: '', countryCode: '', phoneVerified: false });
    }
  };

  checkAlreadyVerified() {
    this.setState({
      phoneVerified:
        this.state.tel === this.state.verifiedNumber &&
        this.state.countryCode === this.state.verifiedCountryCode,
    });
  }

  handleVerify = (success, number, countryCode) => {
    if (success) {
      this.setState({
        phoneVerified: true,
        verifiedNumber: number,
        verifiedCountryCode: countryCode,
      });
    } else {
      this.setState({
        phoneVerified: false,
        verifiedNumber: number,
        verifiedCountryCode: countryCode,
      });
    }
  };

  signup = (e) => {
    e.preventDefault();

    const { dispatch } = this.props;
    dispatch(actions.hideAlert());

    if (this.state.password !== this.state.confirmPassword) {
      dispatch(actions.alert('error', 'Passwords do not match.'));
      // } else if (!this.state.phoneVerified) {
      //   dispatch(actions.alert('error', 'Please verify your phone number.'));
    } else if (!this.state.terms) {
      dispatch(
        actions.alert(
          'error',
          'Please agree to the terms and conditions to continue.'
        )
      );
    } else if (!this.state.turnstileToken) {
      dispatch(actions.alert('error', 'Please complete the security check.'));
    } else {
      const { referrerId, turnstileToken } = this.state;

      let data = {
        avatar: '',
        full_name: this.state.name,
        email: this.state.email.toLowerCase(),
        password1: this.state.password,
        password2: this.state.password,
        // address: this.state.address,
        // city: this.state.city,
        // state: this.state.state,
        // postal: this.state.postal,
        // country: this.state.country,
        // tel: this.state.tel,
        // phone_verified: this.state.phoneVerified,
        // attorney: this.state.attorney,
        referrer: referrerId,
        turnstileToken,
      };

      if (!this.state.referrerId) {
        data = Object.assign({}, data, { referrer: '' });
      } else {
        if (
          _.findIndex(
            REFERRER_IDS,
            (id) => id.toLowerCase() === referrerId.toLowerCase()
          ) === -1
        ) {
          data = Object.assign({}, data, { referrer: '' });
          cookie.remove('referrerId', {
            path: '/',
          });
        } else {
          if (referrerId === 'wim') {
            data['referrer'] = 'WIM';
          }
        }
      }

      dispatch(actions.signup(data));
    }
  };

  handleTurnstile = (turnstileToken) => {
    this.setState({ turnstileToken });
  };

  clearTurnstile = () => {
    this.setState({ turnstileToken: null });
  };

  resetTurnstile = () => {
    this.clearTurnstile();
    if (this.turnstileWidget) {
      this.turnstileWidget.reset();
    }
  };

  render() {
    const { status } = this.props;

    return (
      <div className="signup">
        <h3 className="title">Sign up for Cosynd</h3>

        <p>
          Already have an account? &nbsp;
          <Link to="/login">Click here to sign in.</Link>
        </p>
        <hr className="transparent" />

        <Form onSubmit={this.signup}>
          <Row>
            <Col md={12}>
              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-name">
                    You MUST provide your full legal name
                  </Tooltip>
                }
                placement="right"
              >
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Full name *"
                    autoFocus
                    required
                    id="name"
                    value={this.state.name}
                    onChange={this.handleChange}
                  />
                </FormGroup>
              </OverlayTrigger>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <FormControl
                  type="email"
                  placeholder="Email *"
                  required
                  id="email"
                  value={this.state.email}
                  onChange={this.handleChange}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12} lg={6}>
              <FormGroup>
                <FormControl
                  type="password"
                  placeholder="Password *"
                  required
                  id="password"
                  value={this.state.password}
                  onChange={this.handleChange}
                />
              </FormGroup>
            </Col>
            <Col md={12} lg={6}>
              <FormGroup>
                <FormControl
                  type="password"
                  placeholder="Confirm password *"
                  required
                  id="confirmPassword"
                  value={this.state.confirmPassword}
                  onChange={this.handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* <Row>
                        <Col md={12}>
                        <FormGroup>
                            <FormControl type="text" placeholder="Address *" required
                            id="address" value={this.state.address} onChange={this.handleChange} />
                        </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} lg={4}>
                        <FormGroup>
                            <FormControl type="text" placeholder="City *" required
                            id="city" value={this.state.city} onChange={this.handleChange} />
                        </FormGroup>
                        </Col>
                        <Col md={12} lg={4}>
                        <FormGroup>
                            <FormControl type="text" placeholder="State *" required
                            id="state" value={this.state.state} onChange={this.handleChange} />
                        </FormGroup>
                        </Col>
                        <Col md={12} lg={4}>
                        <FormGroup>
                            <FormControl type="text" placeholder="Zip/Postal *" required
                            id="postal" value={this.state.postal} onChange={this.handleChange} />
                        </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} lg={6}>
                        <FormGroup>
                            <FormControl componentClass="select" required
                            id="country" value={this.state.country} onChange={this.handleCountry}>
                            <option>Select Country</option>
                            {countries.map((country, i) =>
                                <option key={i} value={country.country}>
                                {country.country} ({country.countryCodes[0]})
                                </option>
                            )}
                            </FormControl>
                        </FormGroup>
                        </Col>
                        <Col md={12} lg={6}>
                        <FormGroup className="phone-verify">
                            <FormControl type="text" placeholder="Mobile# *" required
                            id="tel" value={this.state.tel} onChange={this.handleChange} />
                            {this.state.phoneVerified
                            ? <span className="text-green verified">Verified</span>
                            : <span className="text-gray verified">Not verified yet</span>
                            }
                            {this.state.tel && this.state.countryCode &&
                            <PhoneVerify
                                verified={this.state.phoneVerified}
                                phoneNumber={this.state.tel}
                                countryCode={this.state.countryCode}
                                done={this.handleVerify}
                            />
                            }
                        </FormGroup>
                        </Col>
                    </Row>
                    <FormGroup>
                        <ControlLabel>Select all that apply:</ControlLabel>
                    </FormGroup>
                    <FormGroup>
                        <Checkbox checked={this.state.creator} onChange={this.handleCreator}>I am a creator</Checkbox>
                    </FormGroup>
                    <FormGroup>
                        <Checkbox checked={this.state.attorney} onChange={this.handleAttorney}>I am an attorney</Checkbox>
                        <div className="helper-text">By checking this box, I certify that I am a licensed attorney of good standing that is licensed to practice law and that I understand Cosynd’s Terms of Use. I understand that only attorneys in good standing may alter the text of user-generated agreements on Cosynd’s platform.</div>
                    </FormGroup> */}

          <Turnstile
            ref={(widget) => {
              this.turnstileWidget = widget;
            }}
            action="signup"
            onVerify={this.handleTurnstile}
            onExpire={this.clearTurnstile}
            onError={this.clearTurnstile}
          />

          <FormGroup className="actions mt-20px">
            <Checkbox checked={this.state.terms} onChange={this.handleTerms}>
              <span className="text-gray">I agree to Cosynd's </span>
              <a href={COSYND_TERMS_PRIVACY_LINK} target="_blank">
                Terms & Conditions
              </a>
            </Checkbox>
            <div>
              <button disabled={status === actionTypes.AUTH_SIGNUP_REQUEST}>
                {status === actionTypes.AUTH_SIGNUP_REQUEST && (
                  <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>
                )}
                sign up
              </button>
            </div>
          </FormGroup>
        </Form>

        {/* <ReCaptcha
                    sitekey={GOOGLE_RECPATCHA_KEY}
                    action="signup"
                    verifyCallback={this.verifyCallback}
                    /> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  status: state.auth.status,
  error: state.auth.error,
});

export default connect(mapStateToProps)(Signup);



// WEBPACK FOOTER //
// src/components/Auth/Signup.jsx